import { createContext, useContext, useEffect, useState, useMemo, useCallback } from "react";

// Fixed reference rate. Displayed alongside prices so it's clearly indicative.
const USD_TO_INR = 83;

const CurrencyContext = createContext(null);

export function CurrencyProvider({ children }) {
  const [currency, setCurrency] = useState(() => {
    try {
      return localStorage.getItem("apex_currency") || "USD";
    } catch {
      return "USD";
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem("apex_currency", currency);
    } catch {}
  }, [currency]);

  const toggle = useCallback(() => {
    setCurrency((c) => (c === "USD" ? "INR" : "USD"));
  }, []);

  const format = useCallback(
    (usdValue, { round = true } = {}) => {
      if (usdValue == null) return "";
      if (currency === "INR") {
        const inr = usdValue * USD_TO_INR;
        const rounded = round ? Math.round(inr / 100) * 100 : inr;
        return "₹" + rounded.toLocaleString("en-IN");
      }
      return "$" + usdValue.toLocaleString("en-US");
    },
    [currency]
  );

  const value = useMemo(
    () => ({ currency, setCurrency, toggle, format, rate: USD_TO_INR }),
    [currency, toggle, format]
  );

  return <CurrencyContext.Provider value={value}>{children}</CurrencyContext.Provider>;
}

export function useCurrency() {
  const ctx = useContext(CurrencyContext);
  if (!ctx) throw new Error("useCurrency must be used within CurrencyProvider");
  return ctx;
}
